import { Channel } from '@ibe/services';
import PackageListEvent from './Payload/PackageListEvent';
import ExtraComponentListEvent from './Payload/ExtraComponentListEvent';
import InsuranceAddedEvent from './Payload/InsuranceAddedEvent';
import UpsellHotelAddedEvent from './Payload/UpsellHotelAddedEvent';
import EmptyPayload from './Payload/EmptyPayload';

export const packageListEvent = new Channel<PackageListEvent>(
  PackageListEvent,
  'package-list-event'
);

export const itemExtraComponentListEvent = new Channel<ExtraComponentListEvent>(
  ExtraComponentListEvent,
  'extra-component-list-event'
);

export const insurancePopupAddedEvent = new Channel<InsuranceAddedEvent>(
  InsuranceAddedEvent,
  'insurance-added-popup'
);

export const insuranceCheckoutAddedEvent = new Channel<InsuranceAddedEvent>(
  InsuranceAddedEvent,
  'insurance-added-checkout'
);

export const upsellHotelAddedEvent = new Channel<UpsellHotelAddedEvent>(
  UpsellHotelAddedEvent,
  'successful-hotel-upsell'
);

export const upsellPopupDisplayedEvent = new Channel<EmptyPayload>(
  EmptyPayload,
  'upsell-popup-displayed'
);
